import { SET_CURRENT_STORE, SET_STORES_FETCHED, SET_STORES, CLEAR_STORES } from '../Actions/StoreActions';

const initialState = {
  currentStore: null,
  stores: [],
  storesFetched: false
};

const StoreReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case SET_CURRENT_STORE:
      return {
        ...state,
        currentStore: action.payload
      };
    case SET_STORES_FETCHED:
      return {
        ...state,
        storesFetched: action.payload
      };
    case SET_STORES:
      return {
        ...state,
        stores: action.payload
      };
    case CLEAR_STORES:
      return initialState;
    default:
      return state;
  }
};

export default StoreReducer;
